import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Card,
  Divider,
  Box,
  CardMedia,
  Button,
  styled,
  createTheme,
  ThemeProvider
} from '@mui/material';
import moment from 'moment';

const statistiquesEACData = [
  {
    ministere: 'Ministère des Affaires de la Communauté Est Africaine, de la Jeunesse, des Sports et de la Culture',
    annuaires: 'ANNUAIRE DES STATISTIQUES EDITION 2021',
    description: 'Une compilation de données statistiques relatives aux initiatives menées dans le cadre de la coopération régionale, de la promotion de la jeunesse, des sports et de la culture au sein de la Communauté Est-Africaine.',
    date: "2021-12-31",
    link: "/documents/Sectorials/Annuaire-MACEAJSC-SECTEUR-EAC-EDITION-2021-Valide-par-le-CTIS-et-Signe.pdf" 
  },
  {
    ministere: 'Ministère des Affaires de la Communauté Est Africaine, de la Jeunesse, des Sports et de la Culture',
    annuaires: 'ANNUAIRE DES STATISTIQUES EDITION 2020',
    description: 'Données sur les programmes de développement jeunesse et les activités sportives au sein de la région, avec un accent particulier sur les résultats des initiatives et des politiques publiques.',
    date: "2020-12-31",
    link: "/documents/Sectorials/Annuaire-MACEAJSC-SECTEUR-EAC-EDITION-2020-new-pagine3-a-presente-2020-preface.pdf" 
  },
  {
    ministere: 'Ministère des Affaires de la Communauté Est Africaine, de la Jeunesse, des Sports et de la Culture',
    annuaires: 'ANNUAIRE DES STATISTIQUES EDITION 2020',
    description: 'Une vue d’ensemble des initiatives axées sur la culture et le sport, avec des statistiques sur la participation et les résultats des programmes mis en œuvre.',
    date: "2020-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-2020-1.pdf" 
  },
];

function MinistereEAC() {
  const [visibleCount, setVisibleCount] = useState(2); 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C'
      },
      background: {
        default: '#f5f5f5'
      }
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C'
      },
      h4: {
        fontWeight: '600'
      }
    }
  });

  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '20px'
  }));

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 2, statistiquesEACData.length));
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ministère des Affaires Etrangères, de l'Intégration Régionale et de la Coopération au Développement
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les statistiques sur les initiatives menées par le Ministère dans le cadre de la coopération régionale, la promotion de la jeunesse, des sports et de la culture au sein de la Communauté Est-Africaine.
          </Typography>

          {statistiquesEACData.slice(0, visibleCount).map((statistique, index) => (
            <StyledCard key={index} elevation={3}>
              <Box sx={{ display: 'flex' }}>
                <a 
                  href={statistique.link} 
                  style={{ textDecoration: 'none', color: 'inherit' }} 
                   target="_blank"
                  rel="noopener noreferrer"
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 71, height: 100, m: 2 }}
                    image={"path/to/image_placeholder.jpg"} 
                    alt={statistique.annuaires}
                  />
                </a>
                <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                  <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                    <a 
                      href={statistique.link} 
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      {<DownloadIcon />}{statistique.annuaires}
                    </a>
                  </Typography>
                  <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                    {statistique.description}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Publié en {moment(statistique.date).format('MMMM YYYY')}
                  </Typography>
                </Box>
              </Box>
            </StyledCard>
          ))}

      
          {visibleCount < statistiquesEACData.length && (
            <Button 
              onClick={handleShowMore} 
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white'
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereEAC;